import {Injectable} from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {RestTexteService} from '@app/core/api/texte.service';
import {ActiveTextQuery} from '@app/core/state/active-text/active-text.query';
import {ActiveTextStore} from '@app/core/state/active-text/active-text.store';
import {PayloadUtil} from '@app/core/util/payload.util';
import {Textbaustein} from '@pezi/entities';
import {Subscription} from 'rxjs';
import {take} from 'rxjs/operators';
import {setProps} from "@ngneat/elf";

@Injectable({providedIn: 'root'})
export class ActiveTextService {

  private subscription: Subscription;

  constructor(private activeTextStore: ActiveTextStore,
              private activeTextQuery: ActiveTextQuery,
              private textService: RestTexteService,
              private snackBar: MatSnackBar) {
  }

  initText(txtId: string, art: string, sprache: string) {
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.activeTextStore.data.update(setProps({
        loading: false
      }));
    }
    const currentState = this.activeTextStore.data.getValue();
    if (!currentState.text || currentState.text.txtId !== txtId || currentState.text.art !== art || currentState.text.sprache !== sprache) {

      this.activeTextStore.data.reset();
      this.activeTextStore.data.update(setProps({
        loading: true
      }));
      this.subscription = this.textService.getTextDetail(art, txtId, sprache)
        .pipe(
          take(1)
        )
        .subscribe(result => {
          let text: Textbaustein;
          let errorLoadingText = false;
          if (PayloadUtil.handlePayloadSnackbarErrorOnly(result, this.snackBar,
            'Fehler: Text konnte nicht geladen werden')) {
            text = result.data;
          } else {
            errorLoadingText = true;
          }
          this.activeTextStore.data.update(setProps({
            loading:      false,
            errorLoading: errorLoadingText,
            text
          }));
        });
    }
  }

  clearStore() {
    this.activeTextStore.data.reset();
  }
}
